@if (!isScene) {
  <div class="form-group" [formGroup]="formParent">
    <label>Feature</label>
    <select class="form-control form-select mb-2" aria-label=".form-select-sm example" [formControlName]="'id'">
      <option class="fw-bold" [value]="featureService.selectedFeatureID">This Feature</option>
      @for (feature of features$ | async; track feature) {
        @if (feature.type != "button") {
          <option [value]="feature.id">
            {{feature.name}}
          </option>
        }
      }
    </select>
  </div>
}
@if (isScene) {
  <div class="form-group" [formGroup]="formParent">
    <label>Scene</label>
    <select class="form-control form-select mb-2" aria-label=".form-select-sm example" [formControlName]="'id'">
      <option [value]="selectedSceneID">This Scene</option>
      @for (scene of scenes$ | async; track scene) {
        <option [value]="scene.id">
          {{scene.name}}
        </option>
      }
    </select>
  </div>
}